/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Category_NameInputs */

const vi_expense_category_name = /** @type {(inputs: Expense_Category_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên`)
};

/**

* @param {Expense_Category_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_category_name = /** @type {((inputs?: Expense_Category_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Category_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_category_name(inputs)
});